import { MonitoringFeedOverlay } from '#app/routes/mocra+/_form+/components/monitoring-feeds/overlay.tsx'
import { type MonitoringFeedDraft } from '#app/routes/mocra+/_form+/components/monitoring-feeds/types.ts'

type Props = {
	readonly open: boolean
	readonly onOpenChange: (open: boolean) => void
	readonly onSubmit: (draft: MonitoringFeedDraft) => void
	readonly initialValue: MonitoringFeedDraft
	readonly onClosed?: () => void
}

export function MonitoringFeedEditOverlay({
	open,
	onOpenChange,
	onSubmit,
	initialValue,
	onClosed,
}: Props) {
	return (
		<MonitoringFeedOverlay
			mode="edit"
			open={open}
			onOpenChange={onOpenChange}
			onSubmit={onSubmit}
			initialValue={initialValue}
			onClosed={onClosed}
		/>
	)
}
